import { useContext } from 'react';
import { UserContext } from 'shared/Providers/User';
import { Card, CardContent, CardHeader } from '@mui/material';
import { AccountSettingsTitle } from 'shared/_pages/account/styles';
import UserPreferencesCardDesktopAppSettings from 'app/_pages/account/user-preferences-card-desktop-app-settings';
import { IconSettings } from 'shared/_ui/icon';
import SettingsChangePassword from 'shared/_model/settings/settings-change-password';
import SettingsDeleteAccount from 'shared/_model/settings/settings-delete-account';

export default function UserPreferencesCard() {
	const {
		permissions: { canManageAccount },
	} = useContext(UserContext);

	return (
		<Card sx={{ gridColumn: '1/-1' }}>
			<CardHeader avatar={<IconSettings />} title="Local Settings & Preferences" />
			<CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
				{canManageAccount && <UserPreferencesCardDesktopAppSettings />}
				<div>
					<AccountSettingsTitle>Security</AccountSettingsTitle>
					<SettingsChangePassword />
					<SettingsDeleteAccount />
				</div>
			</CardContent>
		</Card>
	);
}
